import { render, staticRenderFns } from "./ButtonSizePagination.vue?vue&type=template&id=47a08534"
import script from "./ButtonSizePagination.vue?vue&type=script&lang=js"
export * from "./ButtonSizePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports